import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { environment } from "./util/baseUrl";
import { AsistenciaEntity } from './Entity/AsistenciaEntity';


export const ListaAsistentes = () => {

    let empty = AsistenciaEntity;

    const baseUrl = environment.baseUrl + "asistenciacurso/";
    const cookies = new Cookies();
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0
    });
    const [EntidadNewDialog, setEntidadNewDialog] = useState(false);
    const { id } = useParams();
    const [product, setProduct] = useState(empty);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const peticionGet = useCallback(async () => {
        setLoading(true);
        try {
            const page = lazyParams.first / lazyParams.rows;
            const response = await axios.get(baseUrl + 'cursos/' + id, {
                params: {
                    page,
                    size: lazyParams.rows
                }
            });
            setData(response.data.content);
            setTotalRecords(response.data.totalElements);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [baseUrl, lazyParams]);


    const onPage = (event) => {
        setLazyParams((prevState) => ({
            ...prevState,
            first: event.first,
            rows: event.rows
        }));
    };

    useEffect(() => {
        if (!cookies.get('role')) {
            navigate('/');
        }
        peticionGet()
    }, [lazyParams]);

    const hideDialogNew = () => {
        setSubmitted(false);
        setEntidadNewDialog(false);
    }

    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    }

    const peticionDelete = async () => {
        await axios.delete(baseUrl + product.id)
            .then(() => {
                const updatedProducts = data.filter(val => val.id !== product.id);
                setData(updatedProducts);
                setDeleteProductDialog(false);
                setProduct(empty);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Asistencia eliminada correctamente', life: 3000 });
            })
            .catch(error => {
                console.log(error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al eliminar el curso', life: 5000 });
            });
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const deleteProduct = () => {
        let _products = data.filter(val => val.id !== product.id);
        peticionDelete();
        setData(_products);
    };

    const deleteProductDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
        </>
    );

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Exportar" icon="pi pi-upload" className="p-button-outlined p-button-help" onClick={exportCSV} />
            </React.Fragment>
        )
    }

    const fecRegistroBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.fecRegistro}
            </>
        );
    }

    const nombreBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.user.nombre + ' ' + rowData.user.apellido}
            </>
        );
    }

    const dniBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.user.docIdentidad}
            </>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.curso.codigo}
            </>
        );
    }

    const tituloBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.curso.titulo}
            </>
        );
    }



    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button title="Eliminar" icon="pi pi-trash" className="p-button-rounded p-button-outlined p-button-warning mr-2" onClick={() => confirmDeleteProduct(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Registro de Asistentes</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" value={globalFilter || ''} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." onKeyUp={() => peticionGet()} />
            </span>
        </div>
    );

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" right={rightToolbarTemplate}></Toolbar>
                    <DataTable ref={dt} value={data} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="id"
                        paginator className="datatable-responsive"
                        lazy scrollable
                        first={lazyParams.first}
                        rows={lazyParams.rows}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        loading={loading}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Certificados"
                        globalFilter={globalFilter} emptyMessage="No existen registros." header={header}>
                        <Column field="fecRegistro" header="Fec. Registro" sortable body={fecRegistroBodyTemplate}></Column>
                        <Column field="user.docIdentidad" header="Doc. Entidad" sortable body={dniBodyTemplate}></Column>
                        <Column field="user.apellido" header="Nombre" sortable body={nombreBodyTemplate}></Column>
                        <Column field="curso.codigo" header="Codigo" sortable body={codigoBodyTemplate}></Column>
                        <Column field="curso.titulo" header="Titulo" sortable body={tituloBodyTemplate}></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>
                    <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {product && <span>Esta seguro de deshabilitar el certificado <b>{product.codigo}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default ListaAsistentes;
